import {EntityType} from "../../gd/const/item"

// gd.bus event fired by a RelationsCollection on every change (its
// onChangeBusEvent). Unlike BUS_TEAMS_CHANGED & co it takes arguments, because
// it is PER ITEM: several views are open at once (a task view over a project
// page), and each has its own collection.
//
// Built from itemType + id rather than the collection instance, because the
// collection is rebuilt on every load while the subscription must survive.
export function BUS_RELATIONS_CHANGED(itemType: EntityType, id: ID): string {
    return `relations-changed:${itemType}:${id}`
}

// Types accepted by the universal public.relation table (related items).
// Mirrors the backend core.const.RelationType: legacy Gantt scheduling
// types (so the table can later absorb project_dependency) plus the
// content-link types used by the related-items feature.
export enum RelationType {
    LINKED         = 1,
    FINISH_START   = 5,
    START_START    = 6,
    FINISH_FINISH  = 7,
    START_FINISH   = 8,
    MENTION_LINK   = 11,   // auto: created from a mention in rich text
    MANUAL_LINK    = 12,   // created by a user by hand
}
